<cigna-icon
  class="flag cg-clickable-icon"
  [class.disabled]="disabled"
  [class.flag-icon-small]="size === 'small'"
  [class.flag-icon-medium]="size === 'medium'"
  [class.active]="flagged"
  (click)="change.emit(flagged)"
  [title]="disabled ? '' : flagged ? removeText : addText"
  [type]="flagged ? 'flag-solid' : 'flag'"
>
</cigna-icon>
